@if (store.allowedSettings()?.length || canViewPlatformBilling()) {
  <div class="flex justify-content-end mb-2">
    <app-button
      label="common.export"
      severity="secondary"
      [loading]="exportPending()"
      [disabled]="exportPending()"
      (clickEvent)="exportOrganization()"
    ></app-button>
    <app-button
      (clickEvent)="exportCsv()"
      class="ml-2"
      label="organization-settings.exportSettings"
      [loading]="settingsExportPending()"
      [disabled]="settingsExportPending()"
    ></app-button>
    <app-button
      (clickEvent)="openImportDialog()"
      class="ml-2"
      label="organization-settings.importSettings"
    ></app-button>
  </div>
  <p-tabs [(value)]="activeTab" [scrollable]="true">
    <p-tablist>
      <p-tab value="basic">{{ 'organization-settings.basic' | translate }}</p-tab>
      @for (settings of store.existingSettings(); track settings) {
        <p-tab [value]="settings.key">
          {{ 'organization-settings.' + settings.key + '.title' | translate }}
          <i [ngClass]="{'ml-3': true, 'pi': true, 'pi-circle-on': true, 'text-success': settings.active, 'text-danger': !settings.active}"
          style="font-size: 0.75rem;"></i>
        </p-tab>
      }
      @if (store.unusedSettings().length) {
        <p-tab value="manage">{{ 'organization-settings.manage' | translate }}</p-tab>
      }
      @if (canViewPlatformBilling()) {
        <p-tab value="platformBilling">{{ 'organization.platformBilling.labelMulti' | translate }}</p-tab>
      }
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="basic">
      </p-tabpanel>

      @for (settings of store.existingSettings(); track $index) {
        <p-tabpanel [value]="settings.key">
          <app-organization-settings [settings]="settings"></app-organization-settings>
        </p-tabpanel>
      }
      @if (store.unusedSettings().length) {
        <p-tabpanel value="manage">
          <div class="integrationsGrid">
            @for (key of store.unusedSettings(); track key) {
              <p-card
                [header]="'organization-settings.' + key + '.title' | translate"
              >
                <div class="flex flex-column justify-content-between gap-3 h-full">
                  <div>{{ 'organization-settings.' + key + '.description' | translate }}</div>
                  <div style="align-self: end;">
                    <app-button severity="success" [label]="'common.add' | translate"
                      (clickEvent)="store.api.getOrCreateOrganizationSetting({ organizationId, key })"
                    ></app-button>
                  </div>
                </div>
              </p-card>
            }
          </div>
        </p-tabpanel>
      }
      @if (canViewPlatformBilling()) {
        <p-tabpanel value="platformBilling">
          <app-organization-platform-billing
            [organizationId]="organizationId"
            [organization]="store.data.getOrganization()"
          ></app-organization-platform-billing>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
}

@if (activeTab === 'basic') {
  <div class="w-full mt-3">
    <app-center-basic-infos [center]="store.primaryOrganizationCenter()"></app-center-basic-infos>
  </div>
  <div class="w-full">
    <div class="w-full mt-3">
      <app-organization-administration-addresses-tile
        [addresses]="store.primaryOrganizationCenter()?.addresses || []"
        [centerId]="store.primaryOrganizationCenter()?.id ?? 0"
      ></app-organization-administration-addresses-tile>
    </div>
  </div>
  <div class="flex flex-wrap">
    <div class="w-full xl:w-6 mt-3">
      <div class="xl:pr-2">
        <app-organization-statutary-representative-table
          [center]="store.primaryOrganizationCenter()!"
        ></app-organization-statutary-representative-table>
      </div>
    </div>
    <div class="w-full xl:w-6 mt-3">
      <div class="xl:pl-2">
        <app-organization-contact-persons-table
          [centerId]="store.primaryOrganizationCenter()?.id || 0"
        ></app-organization-contact-persons-table>
      </div>
    </div>
  </div>
  <div class="w-full mt-3">
    <app-organization-centers-table
      [centres]="store.nonPrimaryOrganizationCenters()"
    ></app-organization-centers-table>
  </div>
}
